import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';
import { CroppedImage } from 'src/app/_models/Common/croped-image';
import { EventModelRequest } from 'src/app/_models/Event/EventModel';
import { Operations } from 'src/app/_models/Operations/Operations';
import { ApiService } from 'src/app/_services/api.service';
import { AuthService } from 'src/app/_services/auth.service';
import { CropAndCompressImageDialogComponent } from '../crop-and-compress-image-dialog/crop-and-compress-image-dialog.component';
import { EventCapacityDialogComponent } from '../event-capacity-dialog/event-capacity-dialog.component';
import { EventStatusTabMapping } from "../../_models/Constants/EventStatusTabMapping";
import { EventStatusEnum } from "../../_models/Enums/EventStatusEnum";

@Component({
  selector: 'app-event-manager',
  templateUrl: './event-manager.component.html',
  styleUrls: ['./event-manager.component.scss'],
})

export class EventManagerComponent implements OnInit {
  loadingPage = false;

  minDate: any

  url: any = '';
  maxChars = 40;
  eventname = '';
  chars = 0;

  rangeDates: Date[];

  description1maxChars = 600;
  description1 = '';

  //asing from venueDetails
  venueId: string = '';
  venueMaxCapacity: number = 0;

  capacity: number = 0;
  createEventForm: UntypedFormGroup = new UntypedFormGroup({});

  submitted = false;
  imagePath: string | ArrayBuffer = './assets/images/logo/Event-Cover-Placeholder.png';

  eventtypesIds: any;

  eventTypeList: any[];

  eventPanelOpenState = true;
  operations = Operations.Add;

  message: string = "";
  navigateToTab: number = 0;

  public errorModel: { [k: string]: any } = {};
  public pastDateTimeErrorMessage = "INFO.DATE_TIME_PAST";

  constructor(
    private apiService: ApiService,
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    public dialogService: DialogService,
    public translate: TranslateService,
    private snackBar: MatSnackBar,
    private authService: AuthService
  ) {
    this.eventTypeList = [
      { name: 'Music & Dance', id: 1 },
      // { name:'Theatre & Performance', id: 2 },
      // { name:'Art & Craft', id: 3 },
      // { name:'Film & Photography', id: 4 },
      { name: 'Nutrition & Cuisine', id: 5 },
      // { name:'Health & Wellness', id: 6 },
      // { name:'Games & Entertainment', id: 7 },
      // { name:'Society & Lifestyle', id: 8 },
      // { name:'Design & Fashion', id: 9 },
      // { name:'Literature & Publishing', id: 10 },
      // { name:'Media & Publicity', id: 11 },
      // { name:'Business & Politics', id: 12 },
    ]
    this.authService.hideNavigationMenuEventEmitter.emit(true);
    this.initCreateEventForm();
    this.minDate = new Date();
  }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        if (params['activeIndex']) {
          this.navigateToTab = +params['activeIndex'];
        }
      });
  }

  private initCreateEventForm() {
    this.createEventForm = new UntypedFormGroup({
      eventName: new UntypedFormControl('', [Validators.required, Validators.maxLength(40)]),
      eventDescription: new UntypedFormControl('', [Validators.required, Validators.maxLength(600)]),
      // rangeDates: new FormControl(this.rangeDates),
      eventDate: new UntypedFormControl('', [Validators.required]),
      startTime: new UntypedFormControl('', [Validators.required]),
      endTime: new UntypedFormControl('', [Validators.required]),
      // eventTime: new FormControl('', [Validators.required]),
      eventImagePath: new UntypedFormControl(''),
    });
  }

  compareDates(formattedStartDate: any, formattedEndDate: any) {
    let startTime = formattedStartDate.getUTCHours() + ":" + formattedStartDate.getUTCMinutes();
    let endTime = formattedEndDate.getUTCHours() + ":" + formattedEndDate.getUTCMinutes();
    if (startTime == endTime) {
      //next day
      formattedEndDate.setDate(formattedEndDate.getDate() + 1);
      return formattedEndDate;
    }
    if (formattedStartDate.getTime() < formattedEndDate.getTime()) {
      //do nothing
      return formattedEndDate;
    }
    if (formattedStartDate.getTime() >= formattedEndDate.getTime()) {
      //next day
      formattedEndDate.setDate(formattedEndDate.getDate() + 1);
      return formattedEndDate;
    }
  }

  onCreateEventFormSubmit(): void {//publish by eventId
    this.errorModel = {}
    this.submitted = true;

    if (this.createEventForm.invalid) {
      return;
    }
    const datepipe: DatePipe = new DatePipe('en-US')
    let datetime1 = new Date(this.createEventForm.value.startTime);
    let timeonly1 = datepipe.transform(datetime1, 'HH:mm:ss');
    let date1 = datepipe.transform(this.createEventForm.value.eventDate, 'yyyy-MM-dd');
    let formattedStartDate = new Date(date1 + "T" + timeonly1);

    let datetime2 = new Date(this.createEventForm.value.endTime);
    let timeonly2 = datepipe.transform(datetime2, 'HH:mm:ss');
    let formattedEndDate = new Date(date1 + "T" + timeonly2)
    formattedEndDate = this.compareDates(formattedStartDate, formattedEndDate);
    let eventModel: EventModelRequest = {};
    eventModel.Name = this.createEventForm.value.eventName;
    eventModel.Title = this.createEventForm.value.eventName;
    eventModel.Description = this.createEventForm.value.eventDescription;
    eventModel.StartDateTime = new Date(formattedStartDate).toISOString();
    eventModel.StartTime = timeonly1 as string;
    eventModel.EndDateTime = new Date(formattedEndDate).toISOString();
    eventModel.EventTypesIds = this.eventtypesIds;
    eventModel.VenueId = this.venueId;
    eventModel.MaxCapacity = this.capacity;
    eventModel.PictureUrl = this.createEventForm.controls['eventImagePath'].value;

    let dateTimeNow = new Date();
    if (dateTimeNow > formattedStartDate) {
      this.errorModel['pastdatetime'] = this.pastDateTimeErrorMessage;
    } else {
      this.errorModel['pastdatetime'] = null;
    }

    if (!this.errorModel['pastdatetime']) {
      this.loadingPage = true;
      const navigateToTab = Object.keys(EventStatusTabMapping)
        .find(key => EventStatusTabMapping[+key] === EventStatusEnum.Published);
      this.apiService.addEvent(eventModel).subscribe(
        (response) => {
          // @ts-ignore
          this.apiService.publishEvent(response.id).subscribe(
            (response) => {
              this.loadingPage = false;
              this.router.navigate(["/promoter/events"], { queryParams: { activeIndex: navigateToTab } });
            },
            (error) => {
              this.loadingPage = false;
              this.snackBar.open('Error', 'Cancel', {
                duration: 3000
              });
            }
          );
        }, (error) => {
          this.loadingPage = false;
          this.snackBar.open(error.error.Message, 'Cancel', {
            duration: 3000
          });
        });
    }
  }

  AddEventAsDraft(): void {
    this.submitted = true;
    if (this.createEventForm.invalid) {
      return;
    }
    const datepipe: DatePipe = new DatePipe('en-US')
    let datetime1 = new Date(this.createEventForm.value.startTime);
    let timeonly1 = datepipe.transform(datetime1, 'HH:mm:ss');
    let date1 = datepipe.transform(this.createEventForm.value.eventDate, 'yyyy-MM-dd');
    let formattedStartDate = new Date(date1 + "T" + timeonly1);

    let datetime2 = new Date(this.createEventForm.value.endTime);
    let timeonly2 = datepipe.transform(datetime2, 'HH:mm:ss');
    let formattedEndDate = new Date(date1 + "T" + timeonly2)
    formattedEndDate = this.compareDates(formattedStartDate, formattedEndDate);
    let eventModel: EventModelRequest = {};
    eventModel.Name = this.createEventForm.value.eventName;
    eventModel.Title = this.createEventForm.value.eventName;
    eventModel.Description = this.createEventForm.value.eventDescription;
    eventModel.StartDateTime = new Date(formattedStartDate).toISOString();
    eventModel.StartTime = timeonly1 as string;
    eventModel.EndDateTime = new Date(formattedEndDate).toISOString();
    eventModel.EventTypesIds = this.eventtypesIds;
    eventModel.VenueId = this.venueId;
    eventModel.MaxCapacity = this.capacity;
    eventModel.PictureUrl = this.createEventForm.controls['eventImagePath'].value;

    let dateTimeNow = new Date();
    if (dateTimeNow > formattedStartDate) {
      this.errorModel['pastdatetime'] = this.pastDateTimeErrorMessage;
    } else {
      this.errorModel['pastdatetime'] = null;
    }

    if (!this.errorModel['pastdatetime']) {
      this.loadingPage = true;
      const navigateToTab = Object.keys(EventStatusTabMapping)
        .find(key => EventStatusTabMapping[+key] === EventStatusEnum.Created);

      this.apiService.addEvent(eventModel).subscribe((response) => {
        this.loadingPage = false;
        this.router.navigate(["/promoter/events"], { queryParams: { activeIndex: navigateToTab } });
      }, (error) => {
        this.loadingPage = false;
        this.snackBar.open(error.error.Message, 'Cancel', {
          duration: 3000
        });
      });
    }
  }

  openCapacity() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.panelClass = 'custom-modal';

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      edit: false,
      venueId: this.venueId,
      venueMaxCapacity: this.venueMaxCapacity,
      venueCapacity: this.capacity
    };

    const dialogRef = this.dialog.open(EventCapacityDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(data => {
      if (data) {
        this.capacity = data;
      }
    });
  }

  selectedVenue(item: any) {
    if (item != null) {
      this.venueId = item.id;
      this.venueMaxCapacity = item.maximumCapacity;
      this.capacity = item.maximumCapacity;
    }
    else {
      this.venueId = "";
      this.venueMaxCapacity = 0;
    }
  }
  cropAndCompressImageDialog() {
    const ref = this.dialogService.open(CropAndCompressImageDialogComponent, {
      data: {
        imagePath: this.imagePath
      },
      autoZIndex: false,
      header: this.translate.instant('PREVIEW'),
      width: '960px',
      contentStyle: { "overflow-y": "auto" },
    });
    ref.onClose.subscribe((image: CroppedImage) => {
      if (image) {
        this.createEventForm.get('eventImagePath')?.setValue(image.imageFile);
        this.imagePath = image.imagePath;
      }
    });
  }

  shareCheckedList(item: any[]) {
    this.eventtypesIds = item;
  }

  get eventFormControls() {
    return this.createEventForm.controls;
  }

}
